<nav role="navigation" class="sideNav">
    <div id="menuToggle" (click)="sideNavBar = !sideNavBar;$event.stopPropagation();">
        <input type="checkbox" class="chkHamburger" [checked]="sideNavBar" />
        <span></span>
        <span></span>
        <span></span>

        <ul id="menu">
            <a href="#" routerLink="/overview" routerLinkActive="active">
                <li>{{labels.home}}</li>
            </a>
            <a href="#" routerLink="/overview" routerLinkActive="active">
                <li>{{labels.about}}</li>
            </a>
            <a href="#" routerLink="/overview" routerLinkActive="active">
                <li>{{labels.settings}}</li>
            </a>
        </ul>
    </div>
</nav>